/**
 * Comprador (Solicitante/Vendedor) padrão a partir do usuário logado no Sankhya, para quem não tem vendedor
 * ligado no cadastro do usuário (TSIUSU.CODVEND). Login do Sankhya -> nome como aparece na lista de compradores.
 */
const NOME_POR_LOGIN: Record<string, string> = {
  'w.richard': 'WILSON RICHARD CARDOSO',
  'a.canto': 'André Honorio Tavares do Canto',
  'g.aires': 'GUILHERME AIRES DOS SANTOS',
  'm.vagner': 'MATHEUS VAGNER BEZERRA',
  'p.lacerda': 'Pabline Lacerda Alves da Silva',
  'd.almeida': 'DOUGLAS ALMEIDA ALVES',
  'g.azevedo': 'GERALDO MARCIO GUEDES DE AZEVEDO',
  'l.marques': 'LEIDMAR MARQUES DOS SANTOS',
  'l.jordan': 'LUIZ JORDAN JIMENEZ JUNIOR',
  'm.castro': 'MARCUS DE OLIVEIRA PEREIRA CASTRO',
  'm.avelar': 'MARIANA AVELAR DE CASTRO',
  'n.figueiro': 'Nathalia Peixoto Figueiro',
  'a.gonzalez': 'ANNIE BRANCAFLOR LOBATO LOUREIRO GONZALE',
  'b.nunes': 'Bruna Nunes da Silva',
  'd.vieira': 'DANIEL JOSE VIEIRA DA SILVA',
  'f.manso': 'Felipe da Silva Manso',
  'f.jose': 'FLAVIO JOSE DA SILVA',
  'chico': 'FRANCISCO LUIZ OSSOVSKI',
  'g.santos': 'GEANDERSON SANTOS DA SILVA',
  'i.rezende': 'IGOR GUILHERME REZENDE',
  'i.lopes': 'IVANEY LOPES RODRIGUES NEVES',
  'j.thiago': 'JEOSAFA THIAGO SILVA DOS SANTOS',
  'j.alex': 'JHON ALEX CABRAL BANDEIRA',
  'l.jacob': 'LETICIA JACOB PEREZ CABRAL',
  'l.oliveira': 'LILIAN RODRIGUES DE OLIVEIRA',
  'm.rebert': 'MAIKON REBERT MIRA DOS SANTOS',
  'm.sauner': 'MELISSA SAUNER',
  'm.felix': 'Murillo Felix de Souza',
  'n.gatti': 'NEVITON GATTI DE ALVARENGA',
  'n.pires': 'Nubia Pires de Sousa',
  'r.borges': 'RAYANE BORGES VIEIRA',
  'r.batista': 'Rubens Batista de Sousa',
  's.nathalia': 'STHEFANE NATHALIA JUREMA SOUZA',
  'v.pereira': 'Vanessa Pereira de Sousa',
  'v.cesar': 'Vinicius Cesar de Abreu',
  'v.brant': 'Vitor Caldeira Brant de Assis',
  'w.carrara': 'WALTER CARRARA PADILHA JUNIOR',
};

const normalizar = (s: unknown): string =>
  String(s ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/\s+/g, ' ').trim();

/** Login (Sankhya) do usuário logado, como guardado no login da aplicação. */
export function loginSankhyaLogado(): string {
  try {
    return (sessionStorage.getItem('sankhyaUsername') || localStorage.getItem('sankhyaUsername') || '').trim();
  } catch {
    return '';
  }
}

/**
 * Procura, na lista de compradores, o do usuário logado pelo nome da tabela acima (ignora acento/caixa e aceita
 * nome truncado). Devolve o codVend ou null.
 */
export function codVendCompradorDoUsuario(
  compradores: { codVend: string | number; apelido: string }[],
  login: string = loginSankhyaLogado()
): string | number | null {
  const nome = normalizar(NOME_POR_LOGIN[(login || '').trim().toLowerCase()]);
  if (!nome) return null;
  const achou = compradores.find(v => {
    const ap = normalizar(v.apelido);
    return ap === nome || (ap.length >= 10 && (nome.startsWith(ap) || ap.startsWith(nome)));
  });
  return achou ? achou.codVend : null;
}
